import { animate } from "motion";

// setTimeout(() => {
//   window.luther.navbar.Overlay._openOverlay();
// }, 100);

(() => {
  const ANIMATION_DURATION = 300;

  class OverlayMenuListCollapsing {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.title = wrapper.querySelector(".luther-overlay-menu-list__title");
      this.content = wrapper.querySelector(".luther-overlay-menu-list__inner");
      this.hasCollapsingControl = false;
      this.handleTitleClickWithBind = this._handleTitleClick.bind(this);

      this._update();
      window.addEventListener("resize", this._update.bind(this));
    }

    _update() {
      if (window.innerWidth < 782) {
        if (!this.hasCollapsingControl) {
          this._create();
          this.hasCollapsingControl = true;
        }
      } else {
        if (this.hasCollapsingControl) {
          this._destroy();
          this.hasCollapsingControl = false;
        }
      }
    }

    _create() {
      this.title.addEventListener("click", this.handleTitleClickWithBind);
      this.wrapper.classList.add("has-collapsing-control");
      this.content.style.height = "0";
      this.content.setAttribute("hidden", "");
      this.title.setAttribute("aria-expanded", "false");
    }

    _destroy() {
      this.title.removeEventListener("click", this.handleTitleClickWithBind);
      this.wrapper.classList.remove("has-collapsing-control");

      this.title.removeAttribute("aria-expanded");
      this.content.removeAttribute("hidden");
      this.content.removeAttribute("entering");
      this.content.removeAttribute("leaving");
      this.content.style.height = "auto";
    }

    _handleTitleClick() {
      const isAlreadyOpen = this.title.getAttribute("aria-expanded") === "true";

      if (isAlreadyOpen) {
        this._closeContainer();
      } else {
        this._openContainer();
      }
    }

    _openContainer(duration = ANIMATION_DURATION) {
      this.content.setAttribute("entering", "");

      this.enteringAnimation = animate(
        this.content,
        { height: `${this.content.scrollHeight}px` },
        { duration: duration / 1000, easing: "ease-out" },
      );

      this.content.removeAttribute("hidden");

      setTimeout(() => {
        this.enteringAnimation = undefined;
        if (this.content.getAttribute("entering") === undefined) return;

        this.content.removeAttribute("entering");
      }, duration);

      this.title.setAttribute("aria-expanded", "true");
    }

    _closeContainer(duration = ANIMATION_DURATION) {
      this.content.setAttribute("leaving", "");

      animate(
        this.content,
        { height: 0 },
        { duration: duration / 1000, easing: "ease-out" },
      );

      setTimeout(() => {
        if (this.content.getAttribute("leaving") === undefined) return;

        this.content.removeAttribute("leaving");
        this.content.setAttribute("hidden", "");
      }, duration);

      this.title.setAttribute("aria-expanded", "false");
    }
  }

  window?.luther?.eventBus?.on(
    "luther:pageContentChange",
    updateLutherOverlayMenuListCollapsingInstances,
  );

  function updateLutherOverlayMenuListCollapsingInstances() {
    document
      .querySelectorAll(".luther-overlay-menu-list--mobile-collapsing")
      .forEach((el) => {
        let wrapper = new OverlayMenuListCollapsing(el);
        window.luther.grids.push(wrapper);
      });
  }

  window.luther = window.luther || {};
  window.luther.grids = [];
  updateLutherOverlayMenuListCollapsingInstances();
})();
